import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, keywords, schema }) => {
  const location = useLocation();
  const pageUrl = `https://elvyen.com${location.pathname === '/' ? '' : location.pathname}`;
  const defaultTitle = 'Elvyen | Web Design & Development Agency India';
  const displayTitle = title ? `${title} | Elvyen` : defaultTitle;
  const displayDescription = description || 'Elvyen is a premium web design and development agency based in New Delhi, India. We build modern websites, web apps, and digital solutions.';
  const displayKeywords = keywords || 'web design, web development, UI/UX, Elvyen';

  useEffect(() => {
    // 1. Update Document Title
    document.title = displayTitle;

    // Helper function to create or update meta tag
    const updateMetaTag = (attributeName, attributeValue, contentValue) => {
      let element = document.querySelector(`meta[${attributeName}="${attributeValue}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attributeName, attributeValue);
        document.head.appendChild(element);
      }
      element.setAttribute('content', contentValue);
    };

    // 2. Standard Meta Tags
    updateMetaTag('name', 'description', displayDescription);
    updateMetaTag('name', 'keywords', displayKeywords);

    // 3. OpenGraph Social Meta Tags
    updateMetaTag('property', 'og:title', displayTitle);
    updateMetaTag('property', 'og:description', displayDescription);
    updateMetaTag('property', 'og:url', pageUrl);

    // 4. Twitter Card Social Meta Tags
    updateMetaTag('name', 'twitter:title', displayTitle);
    updateMetaTag('name', 'twitter:description', displayDescription);
    updateMetaTag('name', 'twitter:url', pageUrl);

    // 5. Canonical Link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', pageUrl);

    // 6. JSON-LD Structured Data Schema Markup
    let schemaScript = document.querySelector('script[type="application/ld+json"][data-seo="true"]');
    if (schemaScript) {
      schemaScript.remove();
    }
    if (schema) {
      schemaScript = document.createElement('script');
      schemaScript.setAttribute('type', 'application/ld+json');
      schemaScript.setAttribute('data-seo', 'true');
      schemaScript.innerHTML = JSON.stringify(schema);
      document.head.appendChild(schemaScript);
    }
  }, [displayTitle, displayDescription, displayKeywords, pageUrl, schema]);

  return null;
};

export default SEO;
